<template>
  <div class="on-board-phase-3">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  mixins: [Fetcher],
  components: {},
  props: ['id'],
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  data() {
    return {}
  },
  mounted: function() {
    let self = this
    self.request(() =>
      self.getOnboardRequestDetails(this.id).then(function(response) {
        if (response.data.candidates.length > 0) {
          self
            .getInstitutionPublicDetails(response.data.candidates[0])
            .then(function(response) {
              self.$store.commit(
                'onBoard/SET_NEOFINTECH_CHOSEN_LOCATION',
                response
              )
            })
        }
        self.$store.commit(
          'onBoard/SET_NEOFINTECH_PHASE_1',
          response.data.phase1
        )
        self.$store.commit(
          'onBoard/SET_NEOFINTECH_PHASE_2',
          response.data.phase2
        )
        self.$store.commit('onBoard/SET_NEOFINTECH_GENERAL', response.data)
      })
    )
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequestDetails']),
    ...mapActions('institutions', ['getInstitutionPublicDetails'])
  }
}
</script>
<style lang="scss">
@import '~@/scss/_mixins.scss';
.on-board-phase-3 {
  background: url('~@/assets/hologram-map-background-yellow.svg') no-repeat;
  background-size: contain;
  background-position: center;
  background-attachment: fixed;
  height: 100%;
  padding-bottom: 60px;

  > section {
    height: 100%;
    overflow-y: scroll;
  }
}
</style>

<style>
/* Page router animation animacion*/
.slide-enter-active,
.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  overflow-x: hidden;
}

.slide-enter,
.slide-leave-active {
  opacity: 0;
  transform: translateX(-50px);
}
.container {
  transition: 0.3s ease-in-out;
}

.on-board-phase-3 .colored h1.title {
  color: #32b208;
}

.on-board-phase-3 .colored p {
  color: #d23085;
  /*font-weight: bolder;*/
  font-size: 16px;
}
</style>
